import { useEffect, useRef } from "react";

import { useRouter } from "../context/RouterContext";

export interface IRedirectProps {
    to: string;
}

export function Redirect(props: IRedirectProps) {
    const { to } = props;
    const { navigate } = useRouter();
    const once = useRef(false);

    useEffect(() => {
        if (!once.current) {
            once.current = true;
            void navigate(props.to);
        }
    }, [to, once, navigate]);

    return null;
}
